import React from "react";
import { Typography } from "@mui/material";
import styled from "@emotion/styled";
import { useTranslation } from "react-i18next";
import { useMandatorContext } from "@rentablo/theming";
import { useGetNewsFeedRentabloBlog } from "@api";
import { ftdNewsFeedData } from "@features/dashboard/components";
import { prepareNewsData } from "@features/dashboard/utils";
import { ShortNews } from "../Dashboard/ShortNews/ShortNews";

const NewsContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(5)};
`;

const Title = styled(Typography)`
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const DashboardPageNews = ({ mode }: { mode: "full" | "short" }) => {
  const { t } = useTranslation();
  const { isFtd } = useMandatorContext();

  const { data, isFetching } = useGetNewsFeedRentabloBlog(
    { includeRandomAlleAktienFeedItem: false },
    { enabled: !isFtd }
  );

  const newsData = isFtd ? ftdNewsFeedData : prepareNewsData(data);

  if (mode === "short") {
    return <ShortNews news={newsData} isFetching={isFetching} />;
  }

  return (
    <NewsContainer>
      <Title variant="body3" color="textSecondary">
        {t("dashboardPage.dashboard.newsBlock.title")}
      </Title>
      <ShortNews news={newsData} isFetching={isFetching} />
    </NewsContainer>
  );
};
